<template>
    <div class="resumeOther language">
        <el-row>
            <el-col :span="4" class="resumeItem">
                <h1>语言</h1>
                <p>{{languageSize}}/5</p>
            </el-col>
            <el-col :span="20">
                <div v-for="(item,index) in resumeInfo.languageList" class="workExpList">

                    <div v-if="!resumeEditStatus" class="editBtn">
                        <!--编辑按钮-->
                        <el-button slot="reference" type="text" icon="el-icon-edit-outline"
                                   @click="edit(item)" v-has-permi="['resume:language:edit']"></el-button>

                        <!--删除按钮-->
                        <el-popconfirm title="确认删除专业语言？"
                                       placement="top-start"
                                       @confirm="deleteLanguage(item.id)"
                                       icon="el-icon-info"
                                       icon-color="red"
                                       v-has-permi="['resume:language:delete']">
                            <el-button slot="reference" type="text" icon="el-icon-delete"></el-button>
                        </el-popconfirm>
                    </div>

                    <div>
                        <!--编辑状态-->
                        <div v-if="editStatus.id==item.id && editStatus.status==true">
                            <div v-if="resumeEditStatus==true && languageEditStatus==true">
                                <language-form :form="form" :resumeId="resumeInfo.id" :editStatus="editStatus" ></language-form>
                            </div>
                        </div>

                        <!--非编辑状态-->
                        <div v-else class="resumeContent">
                            <p class="rateDiv">
                                <b>{{item.name}}</b>
                                <el-rate
                                    class="resumeRate"
                                    disabled-void-icon-class="unActive"
                                    disabled
                                    :max="4"
                                    text-color="#ff9900"
                                    score-template="{value}"
                                    :value="matchRate(item.level)">
                                </el-rate>
                                <span>{{ dictFormatter(levelOptions, item.level) }}</span>
                            </p>
                        </div>
                    </div>

                </div>

                <!--新增简历工作经历表单-->
                <div v-if="editStatus.status==false && resumeEditStatus==true && languageEditStatus==true">
                    <language-form :form="form" :resumeId="resumeInfo.id" :editStatus="editStatus" @editStatus="getEditStatus"></language-form>
                </div>

                <div v-if="languageSize<5 && editStatus.status==false && resumeEditStatus==false && languageEditStatus==false"
                     v-has-permi="['resume:language:add']" class="addExp">
                    <el-button @click="add()" icon="el-icon-plus">添加语言</el-button>
                </div>

            </el-col>
        </el-row>
    </div>
</template>
<script>
    import LanguageForm from './Form/LanguageForm.vue';
    import {deleteLanguage} from '@/api/resume';
    import {getTreeListByDictType} from '@/api/dict';

    export default {
        name: 'language',
        props: ['resumeInfo'],
        data () {
            return {
                // 表单编辑状态
                editStatus: {
                    id: 0,
                    status: false,
                },
                form: {
                    level: '2',
                },
                levelOptions: [],   // 掌握程度
            }
        },
        created() {
            this.loadDictData();
        },
        computed: {
            // 简历编辑状态
            resumeEditStatus(){
                return this.$store.state.index.resumeEditStatus;
            },
            // 简历工作经历编辑状态
            languageEditStatus(){
                return this.$store.state.index.languageEditStatus;
            },
            // 简历工作经历列表数量
            languageSize(){
                return this.size();
            },
            // languageLevel(){
            //     return this.level();
            // }
        },
        methods: {
            loadDictData(){
                getTreeListByDictType("mastery").then(response => {
                    this.levelOptions = response.data
                });
            },
            // 计算简历工作经历数量
            size(){
                let languageSize = 0;
                for(let i in this.resumeInfo.languageList) {
                    languageSize++;
                }
                return languageSize;
            },
            matchRate(item){
                if(item === 'COMMONLY'){
                    return 1
                }else if(item === 'GOOD'){
                    return 2
                }else if(item === 'SKILLED'){
                    return 3
                }else if(item === 'MASTER'){
                    return 4
                }
            },
            // 表单进入编辑状态
            edit(item){
                this.add();
                this.form = Object.assign({}, item);
                this.editStatus.id = item.id;
                this.editStatus.status = true;
            },
            // 简历工作经历表单切换至编辑状态
            add() {
                this.form = {};
                this.$store.commit('changeResumeEditStatus', true);
                this.$store.commit('changeLanguageEditStatus', true);
            },
            // 根据id删除工作经历
            deleteLanguage(id) {
                deleteLanguage(id).then(res => {
                    this.$store.commit('changeResumeRefreshFlag', true);
                })
            },
            getEditStatus(data) {
                this.editStatus = data;
            }
        },
        components: {
            LanguageForm,
        }
    }
</script>
